// import React, { useEffect, useRef, useState } from 'react';
// import Loading from '../Common/Loading';

// const API_BASE = process.env.REACT_APP_DOCUMENT_LINK || 'https://staging.sysadmin.elearnoncloud.com/';
// const LOGIN_ROUTE = '/'; // where the password page lives; adjust if different

// const SysAdminOtp: React.FC = () => {
//   const [digits, setDigits] = useState<string[]>(['', '', '', '']);
//   const [message, setMessage] = useState<string>('');
//   const [maskedEmail, setMaskedEmail] = useState<string>(sessionStorage.getItem('OTP_MASKED_EMAIL') || '');
//   const [loading, setLoading] = useState<boolean>(false);
//   const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
//   const verifyRef = useRef<HTMLButtonElement>(null);

//   // VB would crash on a direct hit without a session; here we send the user back to the login page.
//   useEffect(() => {
//     if (!sessionStorage.getItem('OTP_TOKEN')) {
//       window.location.href = LOGIN_ROUTE;
//       return;
//     }
//     inputRefs.current[0]?.focus();
//   }, []);

//   const clearBoxes = () => {
//     setDigits(['', '', '', '']);
//     inputRefs.current[0]?.focus();
//   };

//   const handleChange = (index: number, raw: string) => {
//     const value = raw.replace(/[^0-9]/g, '').slice(-1);
//     setDigits((prev) => {
//       const next = [...prev];
//       next[index] = value;
//       return next;
//     });
//     if (value) {
//       if (index < 3) inputRefs.current[index + 1]?.focus();
//       else verifyRef.current?.focus(); // last box filled
//     }
//   };

//   const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
//     if (e.key === 'Backspace') {
//       if (!digits[index] && index > 0) {
//         inputRefs.current[index - 1]?.focus();
//       } else {
//         setDigits((prev) => {
//           const next = [...prev];
//           next[index] = '';
//           return next;
//         });
//       }
//     } else if (e.key === 'Enter') {
//       handleVerify();
//     }
//   };

//   const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
//     e.preventDefault();
//     const pasteData = e.clipboardData.getData('text').replace(/[^0-9]/g, '');
//     const next = ['', '', '', ''].map((_, i) => pasteData[i] || '');
//     setDigits(next);
//     const filled = Math.min(pasteData.length, 4);
//     if (filled === 4) verifyRef.current?.focus(); // full OTP -> go to button
//     else if (filled > 0) inputRefs.current[filled - 1]?.focus(); // partial -> last filled
//   };

//   const handleVerify = async () => {
//     setMessage('');
//     setLoading(true);
//     try {
//       const response = await fetch(`${API_BASE}api/login/verify-otp/`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           otpToken: sessionStorage.getItem('OTP_TOKEN'),
//           otp: digits.join(''),
//         }),
//       });
//       const data = await response.json();

//       if (response.ok) {
//         setMessage('OTP verified successfully.');
//         sessionStorage.setItem('MENU_RIGHTS', data.newpermissions);
//         sessionStorage.setItem('S', 'A');
//         sessionStorage.setItem('F', 'AA');
//         sessionStorage.setItem('L', data.login);
//         sessionStorage.setItem('UserName', data.login);
//         sessionStorage.setItem('access_token', data.access);
//         sessionStorage.setItem('refresh_token', data.refresh);
//         sessionStorage.removeItem('OTP_TOKEN');
//         sessionStorage.removeItem('OTP_MASKED_EMAIL');
//         window.location.href = '/SysAdmin';
//       } else {
//         setMessage(data.error || 'Invalid OTP. Please try again.');
//         if (data.clearOtp) clearBoxes();
//       }
//     } catch (err) {
//       setMessage('Verification failed. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResend = async (e: React.MouseEvent) => {
//     e.preventDefault();
//     setMessage('');
//     setLoading(true);
//     try {
//       const response = await fetch(`${API_BASE}api/login/resend-otp/`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ otpToken: sessionStorage.getItem('OTP_TOKEN') }),
//       });
//       const data = await response.json();

//       if (response.ok) {
//         sessionStorage.setItem('OTP_TOKEN', data.otpToken);
//         sessionStorage.setItem('OTP_MASKED_EMAIL', data.maskedEmail || '');
//         setMaskedEmail(data.maskedEmail || '');
//         clearBoxes();
//       } else {
//         setMessage(data.error || 'Could not send a new code. Please try again.');
//       }
//     } catch (err) {
//       setMessage('Could not send a new code. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const boxStyle: React.CSSProperties = {
//     width: 50, height: 56, margin: '0 6px', textAlign: 'center', fontSize: 28,
//     border: '1px solid #999', borderRadius: 4, fontFamily: 'Open Sans, sans-serif',
//   };

//   return (
//     <div style={{ minHeight: '100vh', background: '#f2f2f2', fontFamily: 'Open Sans, sans-serif' }}>
//       <div style={{
//         width: 420, maxWidth: '90%', margin: '0 auto', paddingTop: 80, textAlign: 'center',
//       }}>
//         <div style={{ background: '#fff', padding: '28px 20px', borderRadius: 6, boxShadow: '0 2px 10px rgba(0,0,0,0.15)' }}>
//           <p style={{ fontSize: 22, fontWeight: 'bold', margin: '0 0 12px' }}>Verification Code</p>
//           <p style={{ margin: '0 0 6px' }}>Please enter the verification code sent to your email</p>
//           <p style={{ margin: '0 0 18px', color: '#555' }}>{maskedEmail}</p>

//           <div style={{ marginBottom: 18 }}>
//             {digits.map((d, i) => (
//               <input
//                 key={i}
//                 ref={(el) => { inputRefs.current[i] = el; }}
//                 type="text"
//                 inputMode="numeric"
//                 maxLength={1}
//                 tabIndex={i + 1}
//                 value={d}
//                 style={boxStyle}
//                 onChange={(e) => handleChange(i, e.target.value)}
//                 onKeyDown={(e) => handleKeyDown(i, e)}
//                 onPaste={handlePaste}
//               />
//             ))}
//           </div>

//           <button
//             ref={verifyRef}
//             tabIndex={5}
//             onClick={handleVerify}
//             disabled={loading}
//             style={{
//               background: '#F60', color: '#fff', border: 'none', borderRadius: 3,
//               padding: '10px 36px', fontSize: 16, cursor: 'pointer',
//             }}
//           >
//             Verify
//           </button>

//           <div style={{ minHeight: 28, margin: '14px 0 6px', color: '#b00020' }}>{message}</div>

//           <a href="#" onClick={handleResend} style={{ color: '#2f6089', fontSize: 14 }}>
//             SEND NEW CODE
//           </a>
//         </div>
//       </div>
//       {loading && <Loading />}
//     </div>
//   );
// };

// export default SysAdminOtp;


import React, { useEffect, useRef, useState } from 'react';
import Loading from '../Common/Loading';

const API_BASE = process.env.REACT_APP_DOCUMENT_LINK || 'https://staging.sysadmin.elearnoncloud.com/';
const LOGIN_ROUTE = '/'; // where the password page lives; adjust if different

const SysAdminOtp: React.FC = () => {
  const [digits, setDigits] = useState<string[]>(['', '', '', '']);
  const [message, setMessage] = useState<string>('');
  const [maskedEmail, setMaskedEmail] = useState<string>(sessionStorage.getItem('OTP_MASKED_EMAIL') || '');
  const [loading, setLoading] = useState<boolean>(false);
  const [windowWidth, setWindowWidth] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 1920);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const verifyRef = useRef<HTMLButtonElement>(null);

  // VB would crash on a direct hit without a session; here we send the user back to the login page.
  useEffect(() => {
    if (!sessionStorage.getItem('OTP_TOKEN')) {
      window.location.href = LOGIN_ROUTE;
      return;
    }
    inputRefs.current[0]?.focus();
  }, []);

  // VB OTP.css body rules (margin, font, colour, background, min-width) + page title (<title>SYSADMIN - OTP</title>).
  // Applied on mount and restored on unmount so other pages are not affected.
  useEffect(() => {
    const prevBody = {
      margin: document.body.style.margin,
      fontFamily: document.body.style.fontFamily,
      color: document.body.style.color,
      backgroundColor: document.body.style.backgroundColor,
      backgroundImage: document.body.style.backgroundImage,
      minWidth: document.body.style.minWidth,
    };
    const prevTitle = document.title;

    document.body.style.margin = '0 auto';
    document.body.style.fontFamily = "'Open Sans', sans-serif";
    document.body.style.color = '#fff';
    document.body.style.backgroundColor = '#131414';
    document.body.style.backgroundImage = 'none';
    document.body.style.minWidth = '300px';
    document.title = 'SYSADMIN - OTP';

    return () => {
      document.body.style.margin = prevBody.margin;
      document.body.style.fontFamily = prevBody.fontFamily;
      document.body.style.color = prevBody.color;
      document.body.style.backgroundColor = prevBody.backgroundColor;
      document.body.style.backgroundImage = prevBody.backgroundImage;
      document.body.style.minWidth = prevBody.minWidth;
      document.title = prevTitle;
    };
  }, []);

  // Responsive: track window width so inline styles can react to the same breakpoints as OTP.css
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const clearBoxes = () => {
    setDigits(['', '', '', '']);
    inputRefs.current[0]?.focus();
  };

  const handleChange = (index: number, raw: string) => {
    const value = raw.replace(/[^0-9]/g, '').slice(-1);
    setDigits((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
    if (value) {
      if (index < 3) inputRefs.current[index + 1]?.focus();
      else verifyRef.current?.focus(); // last box filled
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace') {
      if (!digits[index] && index > 0) {
        inputRefs.current[index - 1]?.focus();
      } else {
        setDigits((prev) => {
          const next = [...prev];
          next[index] = '';
          return next;
        });
      }
    } else if (e.key === 'Enter') {
      handleVerify();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text').replace(/[^0-9]/g, '');
    const next = ['', '', '', ''].map((_, i) => pasteData[i] || '');
    setDigits(next);
    const filled = Math.min(pasteData.length, 4);
    if (filled === 4) verifyRef.current?.focus(); // full OTP -> go to button
    else if (filled > 0) inputRefs.current[filled - 1]?.focus(); // partial -> last filled
  };

  const handleVerify = async () => {
    setMessage('');
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}api/login/verify-otp/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          otpToken: sessionStorage.getItem('OTP_TOKEN'),
          otp: digits.join(''),
        }),
      });
      const data = await response.json();

      if (response.ok) {
        setMessage('OTP verified successfully.');
        sessionStorage.setItem('MENU_RIGHTS', data.newpermissions);
        sessionStorage.setItem('S', 'A');
        sessionStorage.setItem('F', 'AA');
        sessionStorage.setItem('L', data.login);
        sessionStorage.setItem('UserName', data.login);
        sessionStorage.setItem('access_token', data.access);
        sessionStorage.setItem('refresh_token', data.refresh);
        sessionStorage.removeItem('OTP_TOKEN');
        sessionStorage.removeItem('OTP_MASKED_EMAIL');
        window.location.href = '/SysAdmin';
      } else {
        setMessage(data.error || 'Invalid OTP. Please try again.');
        if (data.clearOtp) clearBoxes();
      }
    } catch (err) {
      setMessage('Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async (e: React.MouseEvent) => {
    e.preventDefault();
    setMessage('');
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}api/login/resend-otp/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ otpToken: sessionStorage.getItem('OTP_TOKEN') }),
      });
      const data = await response.json();

      if (response.ok) {
        sessionStorage.setItem('OTP_TOKEN', data.otpToken);
        sessionStorage.setItem('OTP_MASKED_EMAIL', data.maskedEmail || '');
        setMaskedEmail(data.maskedEmail || '');
        clearBoxes();
      } else {
        setMessage(data.error || 'Could not send a new code. Please try again.');
      }
    } catch (err) {
      setMessage('Could not send a new code. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // ── Breakpoints, same as OTP.css ──
  const isLE1024 = windowWidth <= 1024;
  const isLE800 = windowWidth <= 800;
  const isLE550 = windowWidth <= 550;
  const isLE350 = windowWidth <= 350;

  // .otp_logo / #yla_logo  (VB: background-image url("../img/yla_logo.png"))
  const logoStyle: React.CSSProperties = {
    display: 'block',
    margin: isLE800 ? '40px auto 26px' : isLE1024 ? '40px auto 26px' : '26px auto',
    height: isLE350 ? 30 : isLE800 ? 40 : isLE1024 ? 50 : 77,
    width: isLE1024 ? '100%' : 400,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    // backgroundImage: `url(${ylaLogo})`, // import ylaLogo from './Image/yla_logo.png' and uncomment to show the logo
  };

  // #otp_div
  const otpDivStyle: React.CSSProperties = {
    display: 'block',
    height: 'auto',
    width: isLE550 ? '85%' : isLE800 ? '70%' : 600,
    minWidth: isLE800 ? 300 : undefined,
    margin: '0 auto',
    marginTop: isLE800 ? 70 : 80,
    backgroundColor: '#fff',
    textAlign: 'center',
    borderRadius: 12,
    paddingTop: isLE800 ? 40 : 50,
    paddingBottom: isLE800 ? 40 : 50,
  };

  // p
  const pStyle: React.CSSProperties = {
    display: 'block',
    width: isLE550 ? '85%' : isLE800 ? '80%' : '100%',
    margin: '0 auto',
    fontSize: isLE800 ? 15 : 20,
    lineHeight: isLE550 ? '18px' : isLE800 ? '20px' : '30px',
    textAlign: 'center',
    color: '#6c6c6c',
    fontWeight:"normal"
  };

  // .otp_title
  const titleStyle: React.CSSProperties = {
    ...pStyle,
    fontSize: isLE550 ? 20 : isLE800 ? 30 : 40,
    lineHeight: isLE550 ? '30px' : isLE800 ? '40px' : '50px',
    marginBottom: 20,
    color: '#000',
    fontWeight: 'normal',
  };

  // #otp_container
  const otpContainerStyle: React.CSSProperties = {
    display: 'block',
    margin: '30px auto',
    height: 'auto',
    minHeight: isLE550 ? 40 : 70,
    width: 'auto',
    minWidth: 150,
    textAlign: 'center',
  };

  // .opt_input
  const boxSize = isLE550 ? 40 : 60;
  const boxStyle: React.CSSProperties = {
    display: 'inline-block',
    margin: '0 auto',
    marginRight: isLE550 ? 10 : isLE800 ? 15 : 20,
    height: boxSize,
    width: boxSize,
    fontSize: isLE550 ? 20 : 25,
    lineHeight: `${boxSize}px`,
    color: '#6c6c6c',
    textAlign: 'center',
    borderRadius: 5,
    border: 'solid 1px #a5a5a5',
  };

  // #btnVerify
  const verifyStyle: React.CSSProperties = {
    display: 'table',
    margin: isLE550 ? '0 auto' : '50px auto',
    height: isLE550 ? 60 : 80,
    width: 'auto',
    backgroundColor: '#ff6600',
    textAlign: 'center',
    paddingLeft: isLE550 ? 50 : 70,
    paddingRight: isLE550 ? 50 : 70,
    fontSize: isLE550 ? 15 : 20,
    border: 'none',
    color: '#ffffff',
    lineHeight: isLE550 ? '60px' : '80px',
    cursor: 'pointer',
  };

  // #lblMessage
  const messageStyle: React.CSSProperties = {
    margin: '20px auto',
    textAlign: 'center',
    fontSize: 20,
    color: isLE800 ? 'black' : '#6c6c6c',
    fontWeight: isLE800 ? 'bold' : undefined,
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#131414', fontFamily: "'Open Sans', sans-serif", color: '#fff' }}>
      <div id="yla_logo" style={logoStyle}></div>

      <div id="otp_div" style={otpDivStyle}>
        <p style={titleStyle}>Verification Code</p>
        <p style={pStyle}>Please enter the verification code sent to your email</p>
        {/* MFA: masked email (VB: pEmail) */}
        <p id="pEmail" style={pStyle}>{maskedEmail}</p>

        <div id="otp_container" style={otpContainerStyle}>
          {digits.map((d, i) => (
            <input
              key={i}
              ref={(el) => { inputRefs.current[i] = el; }}
              type="text"
              inputMode="numeric"
              maxLength={1}
              tabIndex={i + 1}
              value={d}
              style={boxStyle}
              onChange={(e) => handleChange(i, e.target.value)}
              onKeyDown={(e) => handleKeyDown(i, e)}
              onPaste={handlePaste}
            />
          ))}
        </div>

        <button
          id="btnVerify"
          ref={verifyRef}
          tabIndex={5}
          onClick={handleVerify}
          disabled={loading}
          style={verifyStyle}
        >
          Verify
        </button>

        <div id="lblMessage" style={messageStyle}>
          <span>{message}</span><br />
        </div>

        <a href="#" onClick={handleResend}>
          SEND NEW CODE
        </a>
      </div>

      {loading && <Loading />}
    </div>
  );
};

export default SysAdminOtp;